import { render, staticRenderFns } from "./TradeVerify.vue?vue&type=template&id=9b15133e&scoped=true"
import script from "./TradeVerify.vue?vue&type=script&lang=js"
export * from "./TradeVerify.vue?vue&type=script&lang=js"
import style0 from "./TradeVerify.vue?vue&type=style&index=0&id=9b15133e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b15133e",
  null
  
)

export default component.exports